let _ = require("ES/lib/lodash");
let dd = require("ES/lib/dd");
let radio = require("ES/lib/react-pubsub-via-radio.js/radio");
let Modal = require("ES/widgets/Modal");
let esUtils = require("ES/utils/esUtils");
let RadioMixin = require("ES/lib/react-pubsub-via-radio.js/RadioMixin");

module.exports = dd.createClass({
	mixins: [RadioMixin],
	getInitialState(){
		return {
			event_to_save: null
		};
	},
	Radio_setup(){
		return {
			EvaluationScore_show_modal(event, old_event){
				let new_event = _.cloneDeep(event);
				// we need to look up the pd rep in the sitelists
				_.set(new_event, ["Evaluation", "service_recovery"], 1);

				if(!_.isEqual(event, new_event)){
					this.setState({event_to_save: new_event});
				}
			}
		};
	},
	__doIt: esUtils.wrapPreventDefault(function(){
		let {event_to_save} = this.state;
		radio("save_Event").broadcast(event_to_save);
		this.setState({event_to_save: null});
	}),
	__close: esUtils.wrapPreventDefault(function(){
		this.setState({event_to_save: null});
	}),
	render(){
		let {event_to_save} = this.state;
		if(!event_to_save){
			return dd.div();
		}

		return Modal({
				title: "Service Recovery Recommended.",
				buttons: [
					{
						name: "No",
						onClick: this.__close,
						className: "btn btn-default"
					},
					{
						name: "Yes",
						onClick: this.__doIt,
						className: "btn btn-primary"
					}
				],
				onClose: this.__close
			},
			dd.div({className: "row"},
				dd.div({className: "col-sm-3 text-center text-muted"},
					dd.i({
						className: "fa fa-exclamation text-muted",
						style: {fontSize: 100}
					})
				),
				dd.div({className: "col-sm-9"},
					dd.p({className: "preserve-whitespace"},
						"This eval score should cause the event to go into state 'service recovery needed'.\n\nOK to set?"
					)
				)
			)
		);
	}
});



// WEBPACK FOOTER //
// ./src/components/modals/EvaluationScoreChanged.js